<app-breadcrumb [master]="'Administracja'" [parentName]="'Urządzenia'" [name]="'Szczegóły'"></app-breadcrumb>
<mat-tab-group (selectedTabChange)="onTabChange($event)">
  <mat-tab label="Dane">
    <app-device-details-view *ngIf="!modify" [device]="device" (modifyClicked)="modify = true"></app-device-details-view>
    <app-device-add *ngIf="modify" [device]="device" (closeModification)="modify = false; loadDevice()"></app-device-add>
  </mat-tab>

  <mat-tab label="Dokumenty">
    <ng-template matTabContent>
      <div fxLayout="row">
        <button [disabled]="!(userPermissions | async).document.write" mat-stroked-button color="primary" class="add-button" (click)="addDocument()"><mat-icon>add</mat-icon> Dodaj dokument</button>
      </div>
      <div fxLayout="row">

      </div>
      <div fxLayout="row" fxLayoutGap="25px" fxLayoutAlign="start start">

      </div >
      <app-document-list [excludeColumns]="['partnerOrOfwca' , 'contractType', 'insuranceCompany', 'updatedAt']" [documents]="documents" (changed)="loadDocuments()"></app-document-list>
    </ng-template>
  </mat-tab>

  <mat-tab label="Historia zmian">
    <ng-template matTabContent>
      <app-log-list [device]="device"></app-log-list>
    </ng-template>
  </mat-tab>
</mat-tab-group>
